import { HTMLDisplayComponentRequestJSON } from "./../htmlComponent/HTML-Display-Component-Request.JSON";

export class QuestionDetailsHeaderRequestJSON {
    surveyID:Number;
    userName:String;
    email:String;
    companyName:String;
    mobileNumber:Number;
    hHTMLDisplayComponentList: HTMLDisplayComponentRequestJSON[];

    constructor(){
        this.hHTMLDisplayComponentList=new Array<HTMLDisplayComponentRequestJSON>();
    }
}